import { useQuery } from "react-query";
import { getData } from "../../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";

export type TPeopleDetails = {
  first_name?: string;
  last_name?: string;
  id?: number;
  phone_number?: string;
  email?: string;
  address?: string;
  city?: string;
  state?: string;
  country_code?: string;
  funder_person_type?: string;
  govt_identity_type_id?: number;
  date_of_birth?: string;
  govt_identity_type?: string;
  identity_number?: string;
  educational_qualification?: string;
  role?: string;
  work_experience?: string;
  period_in_company_board?: number;
  experience_relevant_to_role?: string;
  pub_date?: string;
  modified_date?: string;
  government_id_file_path?: string;
  proof_of_address_file_path?: string;
  government_id_approval_status?: number;
  proof_of_address_approval_status?: number;
  govt_id_comment?: string;
  proof_of_address_comment?: string;
  nin?: string;
  gender?: string;
  amount?: number;
  currency?: string;
  firstname?: string;
  funder_id?: number;
  key?: number;
  lastname?: string;
  level?: number;
  number_of_shares?: number;
  parent_shareholder_id?: string;
  percentage_shareholding?: number;
  shareholder_type?: string;
  utility_bill_type_id?: number;
};

type TQuery = {
  funderPeopleType: number;
  customerId: number;
};

const getCustomerPeopleDetails = async ({
  funderPeopleType,
  customerId,
}: TQuery) => {
  const { data } = await getData(
    `${ajaxEndpoints.CUSTOMER_PEOPLE_DETAILS}?funder_people_type=${funderPeopleType}&funder_id=${customerId}`,
  );
  return data;
};

export default function useCustomerPeopleDetails({
  funderPeopleType,
  customerId,
}: TQuery) {
  return useQuery<{ data: TPeopleDetails[] }>(
    [{ funderPeopleType, customerId }, "getCustomerPeopleDetails"],
    getCustomerPeopleDetails,
    {
      refetchOnWindowFocus: false,
      enabled: !!customerId && !!funderPeopleType,
    },
  );
}
